/*
 * Product card: variant thumbnails slider (swipe on touch, arrows on desktop).
 */
(function () {
  function updateArrows(list) {
    const track = list.querySelector('[data-variant-track]');
    const prev = list.querySelector('[data-variant-prev]');
    const next = list.querySelector('[data-variant-next]');

    if (!track) {
      return;
    }

    const maxScroll = track.scrollWidth - track.clientWidth;

    if (prev) {
      prev.classList.toggle('is-inactive', track.scrollLeft <= 1);
    }

    if (next) {
      next.classList.toggle('is-inactive', track.scrollLeft >= maxScroll - 1);
    }
  }

  function updateAll() {
    document.querySelectorAll('.product-card__variant-list').forEach(updateArrows);
  }

  document.addEventListener('click', function (event) {
    const arrow = event.target.closest('[data-variant-prev], [data-variant-next]');

    if (!arrow) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const list = arrow.closest('.product-card__variant-list');
    const track = list && list.querySelector('[data-variant-track]');

    if (!track) {
      return;
    }

    const direction = arrow.hasAttribute('data-variant-next') ? 1 : -1;
    track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: 'smooth' });
  });

  document.addEventListener('scroll', function (event) {
    const track = event.target;

    if (track instanceof Element && track.matches('[data-variant-track]')) {
      updateArrows(track.closest('.product-card__variant-list'));
    }
  }, true);

  /*
   * Mouse drag to slide (touch devices swipe natively).
   */
  let drag = null;

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) {
      return;
    }

    const track = event.target.closest('[data-variant-track]');

    if (!track || track.scrollWidth <= track.clientWidth) {
      return;
    }

    drag = { track: track, startX: event.clientX, startScroll: track.scrollLeft, moved: false };
  });

  document.addEventListener('pointermove', function (event) {
    if (!drag) {
      return;
    }

    const deltaX = event.clientX - drag.startX;

    if (!drag.moved && Math.abs(deltaX) > 5) {
      drag.moved = true;
      drag.track.classList.add('is-dragging');
    }

    if (drag.moved) {
      event.preventDefault();
      drag.track.scrollLeft = drag.startScroll - deltaX;
    }
  });

  function endDrag() {
    if (!drag) {
      return;
    }

    const wasDragged = drag.moved;
    const track = drag.track;
    drag = null;

    if (!wasDragged) {
      return;
    }

    // Re-enable snapping so the row settles on a thumbnail
    track.classList.remove('is-dragging');

    // Swallow the click that follows a drag so it doesn't select a swatch
    function suppress(clickEvent) {
      clickEvent.preventDefault();
      clickEvent.stopPropagation();
    }

    document.addEventListener('click', suppress, { capture: true, once: true });

    // If the drag ended outside the track no click fires; don't eat a later one
    setTimeout(function () {
      document.removeEventListener('click', suppress, { capture: true });
    }, 0);

    setTimeout(function () {
      updateArrows(track.closest('.product-card__variant-list'));
    }, 350);
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  window.addEventListener('resize', updateAll);
  window.addEventListener('load', updateAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
})();
